import crownClothing from "../assets/portfolio/crownClothing.png";
import clipboard from "../assets/portfolio/clipboard.png";
import dashboard from "../assets/portfolio/dashboard.png";
import eventPorte from "../assets/portfolio/event-porte.png";
import payazaWebsite from "../assets/portfolio/payaza-website.png";
import payazaBlog from "../assets/portfolio/blog-app.png";
import sloud from "../assets/portfolio/sloud.png";
import fps from "../assets/portfolio/FPS.png";

const portfolios = [
  {
    id: 1,
    src: eventPorte,
    demoLink: "https://www.eventporte.com/",
    githubLink: "https://github.com/SeunJay/Clipboard",
  },
  {
    id: 2,
    src: payazaWebsite,
    demoLink: "https://payaza.africa/",
    githubLink: "https://github.com/SeunJay/Clipboard",
  },
  {
    id: 3,
    src: payazaBlog,
    demoLink: "https://blog-uat.payaza.africa/",
    githubLink: "https://github.com/SeunJay/Clipboard",
  },
  {
    id: 4,
    src: sloud,
    demoLink: "https://front.sloud.app/",
    githubLink: "https://github.com/SeunJay/Clipboard",
  },

  {
    id: 5,
    src: dashboard,
    demoLink: "https://shimmering-zabaione-cc74d6.netlify.app/",
    githubLink: "https://github.com/SeunJay/dashboard",
  },
  {
    id: 6,
    src: fps,
    demoLink: "https://fps-engine.web.app/map/oilpalm",
    githubLink: "https://github.com/releafgroup/fps-client/",
  },
  {
    id: 7,
    src: crownClothing,
    demoLink: "https://crown-clothing-rwwi.onrender.com/",
    githubLink: "https://github.com/SeunJay/crwn-clothing",
  },
  {
    id: 8,
    src: clipboard,
    demoLink: "https://clipboard-website-tailwind.netlify.app/",
    githubLink: "https://github.com/SeunJay/Clipboard",
  },
];

const Portfolio = () => {
  return (
    <div
      name="Portfolio"
      className="w-full bg-gradient-to-b from-gray-800 to-black text-white md:h-scree"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({ id, src, demoLink, githubLink }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={src}
                alt="pic"
                className="rounded-md duration-200 hover:scale-105"
              />

              <div className="flex items-center justify-center">
                <a
                  href={demoLink}
                  className="w-1/2 px-6 py-3 m-4 flex justify-evenly items-center duration-200 hover:scale-105"
                  target="_blank"
                  rel="noreferrer"
                >
                  Demo
                </a>
                {/* <a
                  href={githubLink}
                  className="w-1/2 px-6 py-3 m-4 flex justify-evenly items-center duration-200 hover:scale-105"
                  target="_blank"
                  rel="noreferrer"
                >
                  Code
                </a> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
